module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/icons/align-left.svg
 ** module id = 69
 ** module chunks = 0
 **/